import React from 'react';

const ProductSearchBar = React.memo(({
  searchQuery,
  setSearchQuery,
  filteredProductsCount,
  canManageProducts,
  handleAddNew
}) => {
  return (
    <div className="product-search-bar">
      <div className="product-search-input-wrapper">
        <i className="fas fa-search product-search-icon"></i>
        <input
          type="text"
          className="product-search-input"
          placeholder="Ürün adıyla ara..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {searchQuery && (
          <button
            className="product-search-clear"
            onClick={() => setSearchQuery('')}
            title="Aramayı temizle"
          >
            <i className="fas fa-times"></i>
          </button>
        )}
      </div>
      {searchQuery && (
        <span className="product-search-result-count">
          {filteredProductsCount} sonuç bulundu
        </span>
      )}

      <div className="product-search-actions">
        {canManageProducts && (
          <button className="btn-add-product" onClick={handleAddNew}>
            <i className="fas fa-plus"></i> Yeni Ürün Ekle
          </button>
        )}
      </div>
    </div>
  );
});

export default ProductSearchBar;
